import Vue from 'vue'
import common from './index'
/**
 * 公共过滤器   此文件不允许改动，若有改动，联系李剑|18363003321
 * lijian
 * 每个前端，直接复制使用
 */

/**
 * 隐藏手机号码
 * @param val {Number, String} 转换的字符串对象
 * @param retain {Number} 保留位数
 * @return {String}
 */
Vue.filter('privatePhone', (val, retain = 4) => {
  if (String(val).length !== 11 || retain === 0) return val
  const phone = String(val)
  const digit = 11 - 3 - retain
  const reg = new RegExp(`^(\\d{3})\\d{${digit}}(\\d{${retain}})$`)
  return phone.replace(reg, `$1${'*'.repeat(digit)}$2`)
})

/**
 * 格式化时间
 * @param {*} val
 * @param {*} fmt
 */
Vue.filter('formatDate', (val, fmt) => {
  return common.formatDate(val, fmt)
})
/**
 * 格式化操作者
 * @param {*} val
 */
Vue.filter('optionUserFormat', (val) => {
  if (val) {
    var optionUser = JSON.parse(val)
    return optionUser.realName
  }
  return ''
})

/**
 * 格式化地区
 * @param {*} val
 */
Vue.filter('regionFormat', (val) => {
  return common.regionFormat(val)
})

/**
 * 格式化属性类型
 * @param {*} val
 */
Vue.filter('porpertyFormat', (val) => {
  if (val) {
    if (val == 0) {
      return '台账'
    } else if (val == 1) {
      return '开关量'
    } else if (val == 2) {
      return '模拟量'
    } else if (val == 3) {
      return '累积量'
    }
  } else {
    return ''
  }
})
/**
 * 格式化数据字典
 * @param {*} val
 */
Vue.filter('dictFormat', (val) => {
  const result = common.typeGroupDataFormat(val)
  if (typeof (result) === 'object') {
    return result.typeName
  }
  return result
})

/**
 * 格式化操作者
 * @param {*} val
 */
// Vue.filter('optionUserFormat', (val) => {
//   if (val) {
//     var optionUser = JSON.parse(val)
//     return optionUser.realName + ' | ' + optionUser.orgName
//   }
//   return ''
// })

Vue.filter('formatFileSize', (val) => {
  if (!val) {
    return '-'
  } else if (typeof (val) !== 'number') {
    return '-'
  } else if (val < 1024) {
    return val + 'B'
  } else if (val < 1024 * 1024) {
    return (val / 1024).toFixed(2) + 'KB'
  } else if (val < 1024 * 1024 * 1024) {
    return (val / 1024 / 1024).toFixed(2) + 'M'
  } else {
    return (val / 1024 / 1024 / 1024).toFixed(2) + 'G'
  }
})
